import { PathInfoList } from '../../../../_constants/PathInfoList'
import { warnLog } from '../../../../common/logger/Logger'
import { restApiKey } from '../../../../_constants/Code'
import { httpGet } from '../../../../services/api/AmplifyApi'

export async function fetchMessageTemplates(corporationNumber, payload) {
  try {
    const { periodType, fiscalPeriod, mode, dashboardId, accPeriod } = payload

    const _fiscalPeriod = payload.periodType === 'year' ? convertYear(fiscalPeriod, accPeriod) : payload.fiscalPeriod
    const init = {
      queryStringParameters: {
        period_type: periodType,
        fiscal_period: _fiscalPeriod,
        mode: mode,
        dashboard_id: dashboardId,
        acc_period: accPeriod
      },
      headers: {}
    }

    const res = await httpGet(
      restApiKey.CHROFY_REST_API,
      PathInfoList.Resource.getDashboardMessages(corporationNumber),
      init
    )

    return res.messages
  } catch (error) {
    console.warn(error)
    warnLog('E000001', '', '', '', error)
  }
}

const convertYear = (fiscalPeriod, accPeriod) => {
  const yearGroup = String(fiscalPeriod).match(/(\d{4})年度/)
  const monthGroup = String(accPeriod).match(/(\d{1,2})月/)
  if ([yearGroup, monthGroup].some((x) => !x)) return ''

  let year = Number(yearGroup[1])
  const month = Number(monthGroup[1])

  year = month !== 12 ? year + 1 : year

  return `${year}年${month}月期`
}
